import { observer } from 'mobx-react-lite';
import React from 'react';
import { useAppStateStore } from '#/hooks/useAppStateStore';
import { useIsSmallView } from '#/hooks/useIsSmallView';
import { IconButtonProps } from '@mui/material';
import Box from '@mui/material/Box';
import BookingSummaryPanel from 'components/BookingSummaryPanel';

export interface WithReservationSummaryProps {
    children: React.ReactNode;
    showEdit?: boolean;
    summary?: React.ReactNode;
    closeButtonProps?: IconButtonProps<React.ElementType>;
}

const WithReservationSummary: React.FC<WithReservationSummaryProps> = observer(function WithReservationSummaryComponent({
    children,
    showEdit = false,
    summary,
    closeButtonProps,
}) {
    const appStore = useAppStateStore();
    const isSm = useIsSmallView();
    const hasSummary = Boolean(appStore.selectedReservation || summary);
    const isSummaryVisible = hasSummary && !isSm;

    return (
        <Box
            sx={
                isSummaryVisible
                    ? {
                          width: '100%',
                          display: 'grid',
                          gridTemplateColumns: '1fr 350px',
                          gap: 2,
                      }
                    : {
                          display: 'flex',
                          flex: 1,
                      }
            }
        >
            <Box sx={{ width: '100%', minHeight: '80vh' }}>
                <Box
                    sx={(theme) => ({
                        maxWidth: theme.breakpoints.values.lg,
                        margin: 'auto',
                        width: '100%',
                        boxSizing: 'border-box',
                        paddingX: { xs: theme.spacing(1), sm: theme.spacing(2) },
                    })}
                >
                    {children}
                </Box>
            </Box>
            {summary ? summary : null}
            {!summary && appStore.selectedReservation ? (
                <BookingSummaryPanel closeButtonProps={closeButtonProps} reservation={appStore.selectedReservation} showEdit={showEdit} />
            ) : null}
        </Box>
    );
});

WithReservationSummary.displayName = 'WithReservationSummary';

export default WithReservationSummary;
